export default __webpack_public_path__ + "static/media/SGP_OPS7031__1_.ab4057d7.png";